import React from 'react';
import { Mail, Users, Gift, Sparkles } from 'lucide-react';

const ComingSoonSection: React.FC = () => {
  const comingSoonFeatures = [
    {
      icon: Mail,
      title: 'Digital Invitations',
      description: 'Create and send beautiful digital wedding invitations with integrated RSVP tracking.',
    },
    {
      icon: Users,
      title: 'Guest Management',
      description: 'Easily manage your guest list, RSVPs, dietary requirements, and seating arrangements.',
    },
    {
      icon: Gift,
      title: 'Gift Registry',
      description: 'Set up and manage your wedding gift registry with options for physical and cash gifts.',
    },
    {
      icon: Sparkles,
      title: 'More Features',
      description: 'Stay tuned for more exciting features including virtual wedding planning assistance, vendor collaboration tools, and more!',
    },
  ];

  return (
    <section className="py-20 relative overflow-hidden bg-white">
      <div className="absolute -bottom-40 -right-40 w-96 h-96 rounded-full bg-[#FF4E8E]/5 blur-3xl"></div>
      
      <div className="container-custom relative z-10">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="text-[42px] font-bold font-cormorant-garamond leading-[1.2] text-[#1C1C1E] mb-6">
            Exciting Features <span className="italic text-[#FF4E8E]">Coming Soon</span>
          </h2>
          <p className="font-cormorant-garamond font-normal text-[16px] text-[#535353]">
            We're constantly working to bring you more tools and features to make your wedding planning journey even better.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {comingSoonFeatures.map((feature, index) => (
            <div key={index} className="bg-gradient-to-br from-[#FF69B4]/15 to-[#FFDAB9]/15 p-6 transition-all duration-300 hover:translate-y-[-3px] group relative w-full rounded-2xl">
              <div className="relative">
                <div className="absolute top-4 right-[-32px] z-10 rotate-45">
                  <span className="bg-[#FF4E8E] text-white text-xs font-medium py-1 px-8 shadow-lg rounded">Coming Soon</span>
                </div>
                <div className="bg-white p-6 rounded-xl shadow-xl border border-[#FF4E8E]/20">
                  <div className="w-12 h-12 rounded-full bg-[#FF4E8E]/10 flex items-center justify-center mb-4 group-hover:bg-[#FF4E8E]/20 transition-colors">
                    <feature.icon className="h-6 w-6 text-[#FF4E8E]" />
                  </div>
                  <h3 className="text-[18px] font-bold font-cormorant-garamond mb-2 text-[#1C1C1E]">{feature.title}</h3>
                  <p className="text-[14px] font-cormorant-garamond font-normal text-[#535353]" dangerouslySetInnerHTML={{__html: feature.description.replace(/RSVP tracking|seating arrangements|vendor collaboration/gi, match => `<span class='italic'>${match}</span>`)}} />
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ComingSoonSection;